import type { GateItem, StageId, Track } from '../types/domain'

export interface StageMeta {
  id: StageId
  index: number
  label: string
  blurb: string
}

export const STAGE_META: Record<StageId, StageMeta> = {
  assessment: {
    id: 'assessment',
    index: 1,
    label: 'Assessment',
    blurb: 'Eligibility, AI scoring, feasibility and strategic fit'
  },
  bid: {
    id: 'bid',
    index: 2,
    label: 'Bid',
    blurb: 'Host-body requirements, dossier and guarantees'
  },
  approval: {
    id: 'approval',
    index: 3,
    label: 'Approval',
    blurb: 'Committee decision, stakeholder alignment, funding mandate'
  },
  'plan-build': {
    id: 'plan-build',
    index: 4,
    label: 'Plan & Build',
    blurb: 'Workstreams, schedule, budget, venues and infrastructure'
  },
  readiness: {
    id: 'readiness',
    index: 5,
    label: 'Readiness',
    blurb: 'Domain readiness, test events, integrated assurance'
  },
  'deliver-operate': {
    id: 'deliver-operate',
    index: 6,
    label: 'Deliver & Operate',
    blurb: 'Live operations, legacy benefits and closure'
  },
  outreach: {
    id: 'outreach',
    index: 3,
    label: 'Outreach',
    blurb: 'Ecosystem distribution on the assigned package tier'
  }
}

export const MEGA_MAJOR_STAGES: StageId[] = [
  'assessment',
  'bid',
  'approval',
  'plan-build',
  'readiness',
  'deliver-operate'
]

export const INTERNATIONAL_STAGES: StageId[] = ['assessment', 'approval', 'outreach']

export function stagesForTrack(track: Track): StageId[] {
  return track === 'international' ? INTERNATIONAL_STAGES : MEGA_MAJOR_STAGES
}

export function stageIndex(track: Track, stage: StageId): number {
  return stagesForTrack(track).indexOf(stage)
}

export function nextStage(track: Track, stage: StageId): StageId | null {
  const stages = stagesForTrack(track)
  const i = stages.indexOf(stage)
  if (i < 0 || i === stages.length - 1) return null
  return stages[i + 1]
}

export interface GateSummary {
  total: number
  met: number
  partial: number
  outstanding: number
  percent: number
  cleared: boolean
}

export function summariseGate(items: GateItem[] = []): GateSummary {
  const met = items.filter((i) => i.status === 'met').length
  const partial = items.filter((i) => i.status === 'partial').length
  const outstanding = items.filter((i) => i.status === 'outstanding').length
  const total = items.length
  const percent = total === 0 ? 0 : Math.round(((met + partial * 0.5) / total) * 100)
  return { total, met, partial, outstanding, percent, cleared: total > 0 && met === total }
}

export function trackLabel(track: Track): string {
  if (track === 'mega') return 'Mega Event'
  if (track === 'major') return 'Major Event'
  return 'International Event'
}
